import { render, staticRenderFns } from "./ComprobacionAmexAprobar.vue?vue&type=template&id=089fb0a6&scoped=true&"
import script from "./ComprobacionAmexAprobar.vue?vue&type=script&lang=js&"
export * from "./ComprobacionAmexAprobar.vue?vue&type=script&lang=js&"
import style0 from "./ComprobacionAmexAprobar.vue?vue&type=style&index=0&id=089fb0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089fb0a6",
  null
  
)

component.options.__file = "ComprobacionAmexAprobar.vue"
export default component.exports